module.exports = __webpack_public_path__ + "static/media/25488079_1703514593057058_7526702976294068731_o.24ca1510.jpg";